import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {KnockoutFieldModel} from "../../../../core/components/knockout-field/knockout-field.model";
import {AuditHistoryGroupModel} from "../../../../core/services/audit-history/audit-history-group.model";
import {AuditHistoryService} from "../../../../core/services/audit-history/audit-history.service";
import {$translate, $translateKey} from "../../../../core/services/internationalization/localize.service";

@Component({
  selector: 'sb-audit-history-group',
  templateUrl: './audit-history-group.component.html',
  styleUrls: ['./audit-history-group.component.scss']
})
export class AuditHistoryGroupComponent implements OnInit, OnChanges {

  @Input()
  group: AuditHistoryGroupModel;

  koAuditedBy: KnockoutFieldModel = null;
  koImpersonatedBy: KnockoutFieldModel = null;

  isExpanded = false;
  isCollapsed = true;

  auditedOnLabel = $translateKey("audithistory.label.audited-on");
  operationLabel = $translateKey("audithistory.label.operation");
  updateNumberLabel = $translateKey("audithistory.label.update-number");
  groupLabel = "";

  constructor(private auditHistoryService: AuditHistoryService) {
  }

  ngOnInit(): void {
    this.groupLabel = $translate("audithistory.label.group-label")`${this.group.Operation.displayValue} on ${this.group.AuditedOn.displayValue} by ${this.group.AuditedBy?.displayValue}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.group && this.group && !this.koAuditedBy) {
      this.koAuditedBy = this.auditHistoryService.generateKnockoutReferenceFieldDefinition(this.group.AuditedBy,
        $translate("audithistory.label.audited-by")`Audited by`,
        "User",
        this.group.AuditedBy?.id as string);
    }

    if (changes.group && this.group && !this.koImpersonatedBy) {
      this.koImpersonatedBy = this.auditHistoryService.generateKnockoutReferenceFieldDefinition(this.group.ImpersonatedBy,
        $translate("audithistory.label.impersonated-by")`Impersonated by`,
          "User",
          this.group.ImpersonatedBy?.id as string);
    }
  }

  toggleExpanded() {
    this.isCollapsed = !this.isCollapsed;
    this.isExpanded = !this.isExpanded;
  }
}
